import styled from "styled-components"
import Bricks from "../../images/bricks.svg"

export const LayoutWrapper = styled.div`
	margin: 0 auto;
	background-image: url(${Bricks});
	background-size: 100%;
`
